import { useState } from "react";

interface CardPaymentProps {
  uid?: any;
  amount: number;
  currency?: string;
  loading?: boolean;

  onSubmit: (data: {
    cardNumber: string;
    expiry: string;
    cvv: string;
  }) => void;

  onBack?: () => void;
}

const CardPayment = ({
  uid,
  amount,
  currency = "RF",
  loading = false,
  onSubmit,
  onBack,
}: CardPaymentProps) => {
  const [cardNumber, setCardNumber] = useState("");
  const [expiry, setExpiry] = useState("");
  const [cvv, setCvv] = useState("");

  const handleSubmit = () => {
    onSubmit({ cardNumber, expiry, cvv });
  };

  return (
    <div className="space-y-5 animate-slideIn">
      <p className="text-sm text-gray-600 dark:text-gray-300">
        Pay securely using your debit or credit card.
      </p>

      {/* Card Container */}
      <div className="rounded-2xl border border-gray-200 dark:border-gray-700 p-4 space-y-4 bg-white dark:bg-gray-900 shadow-sm">
        
        {/* Card Number */}
        <div className="space-y-1">
          <label className="text-xs font-medium text-gray-500">
            Card Number
          </label>
          <input
            value={cardNumber}
            onChange={(e) => setCardNumber(e.target.value)}
            type="text"
            placeholder="1234 5678 9012 3456"
            inputMode="numeric"
            className="w-full px-4 py-3 border rounded-xl text-sm
                       focus:outline-none focus:ring-2 focus:ring-indigo-500"
          />
        </div>

        {/* Expiry & CVV */}
        <div className="grid grid-cols-2 gap-3">
          <div className="space-y-1">
            <label className="text-xs font-medium text-gray-500">
              Expiry Date
            </label>
            <input
              value={expiry}
              onChange={(e) => setExpiry(e.target.value)}
              type="text"
              placeholder="MM / YY"
              inputMode="numeric"
              className="w-full px-4 py-3 border rounded-xl text-sm
                         focus:outline-none focus:ring-2 focus:ring-indigo-500"
            />
          </div>

          <div className="space-y-1">
            <label className="text-xs font-medium text-gray-500">
              CVV
            </label>
            <input
              value={cvv}
              onChange={(e) => setCvv(e.target.value)}
              type="password"
              placeholder="•••"
              inputMode="numeric"
              className="w-full px-4 py-3 border rounded-xl text-sm
                         focus:outline-none focus:ring-2 focus:ring-indigo-500"
            />
          </div>
        </div>

        {/* Security Hint */}
        <div className="flex items-center gap-2 text-xs text-gray-500">
          🔒 Your card details are encrypted and never stored
        </div>

        {/* Pay Button */}
        <button
          disabled={loading}
          onClick={handleSubmit}
          className="w-full bg-indigo-600 hover:bg-indigo-700
                     text-white py-3 rounded-xl font-medium transition
                     disabled:opacity-50"
        >
          {loading
            ? "Processing..."
            : `Pay ${currency} ${amount.toFixed(2)}`}
        </button>
      </div>

      {/* Back */}
      {onBack && (
        <button
          onClick={onBack}
          className="text-sm text-gray-500 hover:text-gray-700"
        >
          ← Back
        </button>
      )}
    </div>
  );
};

export default CardPayment;